import React, { FC } from 'react';
import { Shape } from './shape';
import { Percent } from './percent';
import { Container, DiscountValue, rotate, Value } from './styles';
import { MinusIcon } from './minus-icon';

const DATA_QA_DISCOUNT_RELATED_SERVICE = 'discount-related-service';

type Props = {
  value: number;
};

export const Discount: FC<Props> = ({ value }) => {
  return (
    <Container data-qa={DATA_QA_DISCOUNT_RELATED_SERVICE}>
      <Shape />
      <DiscountValue>
        <MinusIcon className={rotate} />
        <Value>{value}</Value>
        <Percent className={rotate} />
      </DiscountValue>
    </Container>
  );
};
